<template>
    <div class="bottom" id="bottom">
        <div class="uk-section uk-section-transparent uk-padding-xlarge-top uk-padding-2xlarge-bottom dr-divider-gray-1 dr-divider-flip-horizontal">
            <div class="uk-container">
                
                <div class="uk-flex uk-flex-between" :class="{mobile: isMobile}">
                    <div class="sidebar filter-wrap uk-visible@m">
                        <department-filter
                            :departments="$root.source.job_data.departments"
                            :active-dept="activeFilters.department[0]"
                            :active-dept-name="activeDeptName"
                            @dept-filtered="$parent.setFilterDept"
                            v-if="!isMobile"
                        ></department-filter>

                        <location-filter
                            :available-locations="availableLocations"
                            :active-locations-name="activeLocationsName"
                            :active-filters="activeFilters"
                            :scrollable="true"
                            @location-filtered="$parent.setFilterLocations"
                            v-if="!isMobile"
                        ></location-filter>
                    </div>
                    <div class="content uk-margin-medium-left@m">

                        <div v-if="activeDept" class="uk-padding uk-border-rounded uk-background-muted uk-margin-large-bottom uk-animation-fade">
                            <div class="uk-h4">{{ activeDept.post_title }}</div>
                            <div>{{ activeDept.post_content }}</div>
                        </div>

                        <div class="search uk-margin-bottom uk-flex uk-flex-middle">
                            <label for="item-search" class="uk-search uk-search-navbar uk-width-1-1">
                                <input v-model.trim="search" type="text" name="item-search" id="item-search" class="uk-input" :placeholder='$t("message.find_role")'>
                                <span v-if="!search.length" class="uk-icon uk-search-icon uk-search-icon-flip" uk-icon="search-navbar"></span>
                                <a v-else class="uk-icon uk-form-icon uk-form-icon-flip" uk-icon="close" @click="search = ''" role='button'></a>
                            </label>
                            <div class="popup-open uk-margin-small-left uk-button uk-button-indigo" v-if="isMobile" @click="showFiltersPopup" role="button" id="filter-button-mobile"><span>{{ $t("message.filters")}}</span><span class="uk-icon" uk-icon="filter"></span></div>
                        </div>

                        <active-filters v-show="filterArgs.length" :items="filterArgs" @filter-arg-removed="$parent.deleteFilterArg" @cleared-filters="$parent.clearFilters(); clearSearch()"></active-filters>

                        <div class="status uk-text-subtitle uk-margin-xlarge-bottom" v-html="list_status_message"></div>

                        <div class="job-list" :class="{table: !isMobile}">
                            <div class="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@l" uk-grid>
                                <div v-for="item in outputJobs" :key="item.id">
                                    <job-item :job="item" :dept-name="getDeptName(item.departments[0])"></job-item>
                                </div>
                            </div>
                        </div>
                        <div class="show-more uk-margin-xlarge-top" v-show="filteredJobs.length > listLength">
                            <div class="row-wrap" @click="showMoreJobs">
                                <button class="uk-button uk-button-primary uk-button-showmore">

                                    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.649 2.35A7.992 7.992 0 0 0 0 8c0 4.42 3.572 8 7.995 8 3.732 0 6.844-2.55 7.735-6h-2.081c-.821 2.33-3.042 4-5.654 4a6.007 6.007 0 0 1-6.004-6c0-3.31 2.692-6 6.004-6 1.661 0 3.142.69 4.223 1.78L8.996 7H16V0l-2.351 2.35z" fill="#2D8FE2" fill-rule="nonzero"/>
                                    </svg>
                                    <span>{{ $t("message.show_more")}}</span>

                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-section uk-section-default uk-padding-3xlarge-top" v-if="benefits">
            <div class="uk-container">
                <div class="uk-h2 uk-text-center uk-margin-xlarge-bottom">{{ benefits.title }}</div>
                <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-large" uk-grid>
                    <div v-for="item in benefits.items">
                        <div>
                            <div class="uk-h5">{{ item.title }}</div>
                            <div class="uk-text-caption">{{ item.description }}</div>
                        </div>
                    </div>
                </div>
                <div class="uk-margin-2xlarge-top">
                    <a :href="url_base + 'about-us'" class="uk-button uk-button-primary uk-margin-auto">
                        <span>{{ $t("message.learn_about_dr") }}</span>
                        <span class="uk-icon" uk-icon="chevron-right"></span>
                    </a>
                </div>
            </div>
        </div>

        <div class="popup-mobile-wrap uk-nav-side-gradient-bottom" v-show="showPopup" v-if="isMobile">
            <div class="popup-wrap filter-wrap js-nav-alphabet-list" id="filters-popup">

                <department-filter :departments="$root.source.job_data.departments" :active-dept="activeFilters.department[0]" :active-dept-name="activeDeptName" @dept-filtered="$parent.setFilterDept"></department-filter>

                <location-filter :available-locations="availableLocations" :active-locations-name="activeLocationsName" :active-filters="activeFilters" :scrollable="false" @location-filtered="$parent.setFilterLocations"></location-filter>

                <div class="button-wrap" @click="closeFiltersPopup">
                    <span class="uk-button uk-button-indigo uk-button-small uk-width-expand" role="button">{{ $t("message.apply_filters")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import bus from '../event-bus';
  import ActiveFilters from './ActiveFilters.vue';
  import DepartmentFilter from './DepartmentFilter.vue';
  import LocationFilter from './LocationFilter.vue';
  import JobItem from './JobItem.vue';

  export default {
    name: 'IndexBottom',
    components: {
      'job-item': JobItem,
      'active-filters': ActiveFilters,
      'department-filter': DepartmentFilter,
      'location-filter': LocationFilter,
    },
    props: ['activeFilters'],
    data() {
      return {
        search: '',
        postsPerPage: 20,
        paginatorIndex: 1,
        currentFilterAccordion: '',
        windowWidth: window.innerWidth,
        showPopup: false,
      }
    },
    computed: {
      filterArgs: function(){
        // Formatted filter parameters used to build a list of active filters below search field
        let args = [];
        for (let item in this.activeFilters){
          if (this.activeFilters.hasOwnProperty(item) && this.activeFilters[item].length){
            for (let el of this.activeFilters[item]){
              args.push({
                type: item,
                value: el,
                displayName: this.getLocationName(el).charAt(0) ===  this.getLocationName(el).charAt(0).toUpperCase()?  this.getLocationName(el) : this.getDeptName(el),
              });
            }
          }
        }
        return args;
      },
      activeDept: function(){
        if (this.activeFilters.department.length) {
          return this.getDept(this.activeFilters.department[0])
        } else {
          return ''
        }
      },
      activeDeptName: function(){
        if (this.activeFilters.department.length) {
          return this.getDeptName(this.activeFilters.department[0])
        } else {
          return ''
        }
      },
      activeLocationsName: function(){
        switch (this.activeFilters.locations.length) {
          case 0:
            return this.$t("message.all_locations");
          case 1:
            return this.getLocationName(this.activeFilters.locations[0]);
          default:
            return this.activeFilters.locations.length + ' ' + this.$tc('message.location', 1);
        }
      },
      filteredByDept: function(){
        if (this.activeFilters.department.length) {
          return this.$root.source.job_data.jobs.filter(item => {
            return item.departments[0] === this.activeFilters.department[0]
          });
        }

        return this.$root.source.job_data.jobs;
      },
      filteredByLocation: function(){
        if (this.activeFilters.locations.length) {
          return this.filteredByDept.filter(item => {
			  let decider = false;
			  for (let key in item.Locations){
				  if (this.activeFilters.locations.indexOf(item.Locations[key].id) > -1){
					  decider = true;
				  }
			  }
			  return decider;
          });
        }

        return this.filteredByDept;
      },
      filteredJobs: function(){
        let filteredJobs = this.$root.source.job_data.jobs;

        if (this.filteredByDept){
          filteredJobs = this.filteredByDept;
        }

        if (this.filteredByLocation){
          filteredJobs = this.filteredByLocation;
        }

        if (this.search.length){
          filteredJobs = filteredJobs.filter(item => {
            return item.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                   item.JobDescription.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          });
        }

        //return this.$root.source.job_data.jobs // -- show all posts

        return filteredJobs;
      },
      availableLocations: function(){
        let locations = [];
        for (let job of this.filteredByDept){
			for ( let location in job.Locations){
                locations.push(job.Locations[location]);
			}
        }

        // Remove duplicate locations
        locations = locations.filter((item,index) => {
            return index === locations.findIndex(obj => {
                return JSON.stringify(obj) === JSON.stringify(item);
            });
        });

        // Sort locations alphabetically
        locations.sort(function (a,b) {
            if (a.name < b.name)
              return -1;
            if (a.name > b.name)
              return 1;
            return 0;
        })

        return locations;
      },
      listLength: function(){
        return this.postsPerPage * this.paginatorIndex
      },
      currentJobCount: function(){
        return this.filteredJobs.length
      },
      list_status_message: function(){

        // Mind the spaces in string portions!

        if (this.currentJobCount > 0) {
            if (this.activeFilters.department.length) {
                return this.$tc('message.view_dept_pos', this.currentJobCount, { number: this.currentJobCount, department: this.activeDeptName, location: this.activeLocationsName });
            } else {
                return this.$tc('message.view_open_pos', this.currentJobCount, { number: this.currentJobCount, location: this.activeLocationsName });
            }
        } else {
          if (this.search.length) {
            return this.$t('message.no_items');
          } else {
              return this.$t('message.no_open_dept', { department: this.activeDeptName, location: this.activeLocationsName });
          }
        }
      },
      outputJobs: function(){
        return this.filteredJobs.slice(0, this.listLength);
      },
      isMobile: function(){
        return this.windowWidth < 1024
      },
      jobs: function(){
        let jobs = {'other': []};
        for (let post of this.$root.source.job_data.jobs) {
          if (post.hasOwnProperty('internal_job_id')){
            if (!jobs.hasOwnProperty(post.internal_job_id)) {
              jobs[post.internal_job_id] = {
                'title': post.title,
                'department': post.departments[0],
                'locations': [post.location],
                'job_posts': [post],
              };
            } else {
              jobs[post.internal_job_id]['locations'].push(post.location);
              jobs[post.internal_job_id]['job_posts'].push(post);
            }
          } else {
            jobs.other.push(post);
          }
        }

        return jobs;
      },
      benefits: function() {
        return this.$root.source.page.benefits;
      },
      url_base: function(){
        return window.careers_data.locale === 'en' ? '/' : '/jp/';
      },
    },
    watch: {
      /**
       *  Watch for the filteredJobs array to change and reset the pagination if this happens
       */
      filteredJobs: function(){
        this.paginatorIndex = 1;
      },
        showPopup: function(newVal) {
            if (newVal) {
                document.body.classList.add('popup-open');
            } else {
                document.body.classList.remove('popup-open');
            }
        }
    },
    methods: {
      clearSearch: function(){
        this.search = '';
      },
      toggleFilterAccordion: function(a){
        if (this.currentFilterAccordion === a){
          this.currentFilterAccordion = '';
        } else {
          this.currentFilterAccordion = a;
        }
      },
      getDept: function(deptID){
        if (deptID !== undefined) {
          return this.$root.source.departments.filter(function(d){ return d.dept_ID === deptID })[0];
        } else {
          return '';
        }
      },
      getDeptName: function(deptID){
        if (deptID !== undefined) {
          let department = this.$root.source.job_data.departments.filter(function(d){ return d.id === deptID })[0];
          return department ? department.name : deptID;
        } else {
          return '';
        }
      },
      getLocationName: function(locationID){
        if (locationID !== undefined) {
          let location = this.$parent.allLocations.filter(function(l){ return l.id === locationID })[0];
          return location ? location.name : locationID;
        } else {
          return '';
        }
      },
      showMoreJobs: function(){
        this.paginatorIndex++;
      },
      handleResize: function(event){
        this.windowWidth = event.currentTarget.innerWidth;
      },
      showFiltersPopup: function(){
        this.showPopup = true;
      },
      closeFiltersPopup: function(){
        this.showPopup = false;
      },
      handleClick: function(event){
        if ( this.showPopup && event.target !== document.getElementById('filters-popup') &&  !document.getElementById('filters-popup').contains(event.target) && !document.getElementById('filter-button-mobile').contains(event.target)){
          this.closeFiltersPopup();
        }
      },
    },
    created: function() {
      bus.$on('close-filter-popup', (data) => {
        this.closeFiltersPopup();
      });
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize);
    //   window.addEventListener('click', this.handleClick);
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize);
    //   window.removeEventListener('click', this.handleClick);
    }
  };
</script>

<style lang="scss">
    .uk-nav-side-gradient-bottom::after {
        bottom: 96px;
    }
</style>
